export const ADD_ALERT = "ADD_ALERT";
export const ADD_ALERT_SUCCESS = "ADD_ALERT_SUCCESS";
export const ADD_ALERT_FAIL = "ADD_ALERT_FAIL";

export const GET_ALERTS = "GET_ALERTS";
export const GET_ALERTS_SUCCESS = "GET_ALERTS_SUCCESS";
export const GET_ALERTS_FAIL = "GET_ALERTS_FAIL";

export const UPDATE_ALERT = "UPDATE_ALERT";
export const UPDATE_ALERT_SUCCESS = "UPDATE_ALERT_SUCCESS";
export const UPDATE_ALERT_FAIL = "UPDATE_ALERT_FAIL";

export const DELETE_ALERT = "DELETE_ALERT";
export const DELETE_ALERT_SUCCESS = "DELETE_ALERT_SUCCESS";
export const DELETE_ALERT_FAIL = "DELETE_ALERT_FAIL";
